export const environment = {
  production: false,
  apiUrl: 'https://staging-api.tripointehomes.com',
  graphQlUrl: 'https://staging-api.tripointehomes.com/graphql',
  azureSso: {
    clientId: 'fa09acaf-c1ed-4c6b-a458-c8ddd63578a1',
    scope: 'Login',
    tenantId: '14a71f43-9f73-4aaa-9ed6-daef960c5d0a',
    redirectUri: 'https://staging-admin.tripointehomes.com/auth/sso-login'
  }
};
